import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'UniformAuthService',
    controller: 'UserInfo'
}
const methods = [
    'AddItem',
    'UpdateItem',
    'UpdateUserEnable',
    'DelItem',
    'GetItemById',
    'GetItemPagingList',
    'GetAllItems',
    'UserLogin',
    'GetUserByLoginInfo',
    'ChangePassword',
    'GetUserAuth',
    'GetUserAuthWithPsw',
    'FindUserSystems',
    'FindByConditions'
]

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
}

const UserApi = ZJApi.defineNewApi('UserApi', factory)

export default UserApi